"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fixPrecision_1 = __importDefault(require("./fixPrecision"));
function adjustNumber(value, digits) {
    if (value == null)
        return 0;
    const digitsAdjust = Math.pow(10, digits);
    return (0, fixPrecision_1.default)(Math.round(value * digitsAdjust) / digitsAdjust);
}
exports.default = adjustNumber;
//# sourceMappingURL=adjustNumber.js.map